import { FoodMenuResponse } from './models';
import { createQuery } from '../../libs';
import { long_term_cashing } from '@/constants/cashing';

export interface FinderResultsRequest {
  cityId: number;
}

export const useGetFoodMenus = createQuery<FoodMenuResponse, unknown>(
  {
    method: 'get',
    url: `food-menu?page=1&limit=100`,
  },
  {
    staleTime: long_term_cashing,
  }
);
